const SIZES = {
    SMALL: 480,
    MEDIUM: 720,
    LARGE: 1280,
    LARGE_PLUS: 1400
};

const isLargePlusScreen = function () {
    return window.innerWidth >= SIZES.LARGE_PLUS;
};
const isLargeScreen = function() {
    return window.innerWidth < SIZES.LARGE_PLUS && window.innerWidth >= SIZES.LARGE ;
};
const isMediumScreen = function() {
    return window.innerWidth < SIZES.LARGE && window.innerWidth >= SIZES.MEDIUM;
};
const isSmallPlusScreen = function() {
    return window.innerWidth < SIZES.MEDIUM && window.innerWidth >= SIZES.SMALL;
};
const isSmallScreen = function () {
    return window.innerWidth < SIZES.SMALL;
};

export {
    isLargePlusScreen,
    isLargeScreen,
    isMediumScreen,
    isSmallPlusScreen,
    isSmallScreen,
    SIZES
}
